import { LOGOUT, SET_MEMBER, SET_NAV_LIST, SET_USER } from "./mutationTypes";

export default {
  [LOGOUT](state) {
    state.login = false;
    state.userInfo = {
      userEmail: null,
      userImage: null,
      userNickname: null,
    };
    state.userBonusPoints = null;
    window.sensors.logout();
    state.commonSensor = {
      platform_type: "redeem",
      vip_level: "",
      country_station: "Renogy US",
    };
  },
  [SET_USER](state, { userImage, userNickname, userLevelInfo, userEmail }) {
    state.userInfo.userEmail = userEmail;
    state.userInfo.userImage = userImage;
    state.userInfo.userNickname = userNickname;
    state.commonSensor.vip_level = userLevelInfo;
  },
  [SET_MEMBER](state, userBonusPoints) {
    state.userBonusPoints = userBonusPoints;
  },
  [SET_NAV_LIST](state, navList) {
    state.navList = navList;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js